import { atom } from "nanostores";
export const checkoutProduct = atom<any>(null);
export const selectedProduct = atom<any>(null);
export const paymentInfo = atom<any>(null);
export const errorMessage = atom<any>(null);
export const brandSettings = atom<any>(null);
